import { isSomeEnum } from '../enum';

export enum LanguageCode {
  EN = 'en',
  ES = 'es',
}

export const languageCodes = Object.values(LanguageCode);

export enum LanguageCodeMap {
  en = 'en_US',
  es = 'es_ES',
}

export const isLanguageCode = isSomeEnum(LanguageCode);

export const availableLanguages: { [index: string]: string } = {
  [LanguageCode.EN]: 'English',
  [LanguageCode.ES]: 'Spanish',
};

export const languageCodeEmojiMap: { [index: string]: string } = {
  en: '🇺🇸',
  es: '🇪🇸',
  en_US: '🇺🇸',
  en_GB: '🇬🇧',
  en_AU: '🇦🇺',
  es_ES: '🇪🇸',
};

export const USER_LANGUAGE_LOCALSTORAGE_KEY = 'user:language';
